<template>
  <div>
    <v-card class="pl-5 pr-5">
      <h1>Subscribed Collections</h1>
      <v-divider></v-divider>

      <div class="row">
        <div class="pl-3 col-6">
          <v-text-field
            id="search"
            v-model="Search"
            label="Search"
            required
            append-outer-icon="mdi-table-search"
            @click:append-outer="onSearch"
            v-on:keyup.enter="onSearch()"
          ></v-text-field>
        </div>
        <div class="col-6"></div>
      </div>

      <div class="row">
        <div class="col">
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Description</th>
                  <th class="text-left">Detail</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in list" :key="item.id">
                  <td>{{ item.Name }}</td>
                  <td>{{ item.Description }}</td>
                  <td>
                      <router-link
                        :to="{
                          name: 'OrgCollectionDetail',
                          params: {
                            id: item.id,
                            page: paging.page,
                            name: item.Name,
                            description:item.Description
                          }
                        }"
                      >
                        <v-icon small color="blue darken-2">
                          mdi-domain
                        </v-icon>
                      </router-link>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <Pagination :paging="paging" v-on:next="onNextPage" />
        </div>
      </div>

      <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <PublicationCollections ref="publications" />
  </div>
</template>

<script>
import Notification from "@/components/Notification";
import ConfirmationDialog from "@/components/ConfirmationDialog";
import Pagination from "@/components/Pagination";
import PublicationCollections from "@/components/PublicationCollections";
import * as api from "@/api";

export default {
  name: "OrgCollections",
  components: {
    Notification,
    ConfirmationDialog,
    Pagination,
    PublicationCollections
  },
  props: {
    //organization: { type: Object, required: true },
  },
  mounted() {
    this.getCollectionByPagin();
  },

  methods: {
    getCollectionByPagin() {
      let that = this;
      this.list = [];
      that.overlay = true;
      new Promise((resolve, reject) => {
        api
          .getByPagin("purchase-order/organization-collection", this.paging)
          .then(response => {
            this.paging.count = response.data.count;
            response.data.data.forEach(element => {
              this.list.push(element);
            });
            console.log(this.list);
            that.overlay = false;
          })
          .catch(error => {
            reject(error);
            that.overlay = false;
          });
      });
    },
    onNextPage(page) {
      console.log("onNextPage " + page);
      this.paging.page = page;
      this.paging.keyword = this.Search;
      console.log(this.paging);

      this.getCollectionByPagin();
    },
    onSearch() {
      this.paging.page = 1;
      this.paging.keyword = this.Search;
      this.getCollectionByPagin();
    },
    onPopup(item) {
      this.$refs.publications.open("Publications", item.collections.id);
    }
  },

  data() {
    return {
      list: [],
      Search: "",
      loading: false,
      paging: { count: 0, page: 1, size: 10, keyword: "" },
      dialog: false,
      overlay: false
    };
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Organization/OrgCollections.vue